module.exports = __webpack_public_path__ + "img/brook_rd_b4.200765fd.jpg";